import {Header, Layout} from "@components/common";
import {serverSideTranslations} from "next-i18next/serverSideTranslations";
import {fetchJson, getShopNavigation, redirectTo404Page} from "../index";
import {useState} from "react";
import Image from "next/image";
import {getStrapiMedia} from "@utils/strapi";
import delve from "dlv";
import {Button} from "@components/ui";
import s from "../news/news.module.scss";
import {useTranslation} from "next-i18next";

export interface File {
  name: string,
  alternativeText: string,
  caption: string,
  width: number,
  height: number,
  formats: any,
  hash: string,
  ext: string,
  mime: string,
  size: string,
  url: string,
  previewUrl?: string,
  provider: string,
  createdAt: string,
  updatedAt: string,
}

export interface PressKit {
  id: number
  attributes: {
    Name: string,
    Copyright: string,
    createdAt: string,
    updatedAt: string,
    publishedAt: string,
    File: {
      data: {
        attributes: File
      }
    },
    Image: {
      data: {
        attributes: File
      }
    }
  }
}

export function getPresskits(): any {
  return new Promise(async (resolve) => {
    let url = `${process.env.NEXT_PUBLIC_API_URL || "http://localhost:1337"}/api/press-kits?populate=*`;
    const presskits: any = await fetchJson(
      url,
      'data'
    );
    resolve(presskits);
  });
}

export async function getServerSideProps(context: any) {
  try {
    const { locale } = context;
    const presskits: PressKit[] = await getPresskits();
    return {
      props: {
        ...(await serverSideTranslations(locale, ["common", "home"])),
        ...(await getShopNavigation(locale)), // makes "ShopNavigationColumn" property available on page props
        presskits,
        locale
      }
    };
  } catch (error) {
    console.error(error)
    return  redirectTo404Page();
  }
}

export default function Press(data: any) {

  let [presskits, setPresskits] = useState(data.presskits);
  let [locale, setLocale] = useState(data.locale);

  const downloadFile = (url: string) => (e: any)=> {
    const a = document.createElement("a");
    a.href = url;
    a.download = url;
    a.target = "_blank";
    a.click();
    window.URL.revokeObjectURL(url);
  }
  const { t } = useTranslation("common");
  return (
    <div className="container-rg">
      <Header></Header>
      <main className="md:flex flex-row-reverse mb-6">
        <div className="md:flex-1">
          <h1>{t("press-kits").toUpperCase()}</h1>
          <div className="my-6 grid grid-cols-1 md:grid-cols-3 lg:grid-cols-2 xl:grid-cols-3 gap-6">
            {
              presskits.map(((presskit: PressKit, index: number) => {
                return (

                  <div key={index} onClick={downloadFile(presskit.attributes.File.data.attributes.url)}>
                    <div className={s.pressDownloadContainer}>
                    <Image
                      className="aspect-square object-cover line-height-1 hover:scale-105 transition-transform duration-500"
                      src={getStrapiMedia(delve(presskit.attributes.Image, 'data.attributes.url')) || ""}
                      alt={delve(presskit.attributes.Image, 'data.attributes.alternativeText') || ""}
                      width={600}
                      height={600}
                      priority={false}
                      quality="85"
                    />
                      <Button variant={"flat"} onClick={downloadFile(presskit.attributes.File.data.attributes.url)}>{t("download")}</Button>
                    </div>
                    <div className="-mt-5 px-4 py-3 bg-white md:mr-4 relative flex justify-between items-center">
                      <h4>{presskit.attributes.Name}</h4>
                    </div>

                  </div>
                )
              }))
            }
          </div>
        </div>
      </main>


    </div>
  )
}

Press.Layout = Layout
